<template>
  <!--   eslint-disable-next-line vue/no-deprecated-dollar-listeners-api -->
  <Component :is="tag" v-bind="$attrs" @click="emit('click')">
    <slot :analytics-handler="analyticsHandler" />
  </Component>
</template>

<script lang="ts" setup>
import type { AnalyticEvents } from '@/models'

const props = defineProps({
  event: {
    type: String,
    required: true,
  },
  eventValue: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  dontSendRequiredValuesNeed: {
    type: Boolean,
    required: false,
    default: false,
  },
  eventData: {
    type: String,
    required: false,
    default: '',
  },
  yandexMetrika: {
    type: Boolean,
    required: false,
  },
  tag: {
    type: null,
    default: 'div',
    required: false,
  },
})

const emit = defineEmits<{
  (e: 'click'): void
}>()

const { createAnalyticsEvent } = useAnalyticsStore()

function analyticsHandler(obj?: any) {
  createAnalyticsEvent({
    event: props.event as AnalyticEvents,
    value: {
      ...props.eventValue,
      ...obj,
    },
    isRequiredValuesNeed: !props.dontSendRequiredValuesNeed,
    yandexMetrika: props.yandexMetrika,
    eventData: props.eventData as 'short' | 'full',
  })
}
</script>
